import { render, staticRenderFns } from "./red-wine-full.vue?vue&type=template&id=50e34762"
import script from "./red-wine-full.vue?vue&type=script&lang=js"
export * from "./red-wine-full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports